
import { useEffect, useState } from 'react';
import './App.css';

const getlocaldata = ()=>{
   const list = localStorage.getItem("mytodolist");
   if(list){
    return JSON.parse(list);
   }
   else{
    return [];
   }
}

function App() {

  const [inputData, setinputData] = useState('');
  const [items, setitems] = useState(getlocaldata);
  const additem = ()=>{
    if(!inputData){
      alert("Please Enter data");
    }
    else{
      const newinputdata= {
        id: new Date().getTime().toString(),
        name: inputData
      }
      setitems([...items, newinputdata]);
      setinputData('');
    }
  };

  const deleteone = (index)=>{
    const filteritems = items.filter((currElem) =>{
      return currElem.id !== index;
    });
    setitems(filteritems);
  }; 
  useEffect(()=>{
    localStorage.setItem("mytodolist", JSON.stringify(items))
  },[items])
  return (
    <>
    <div className='wrapper flex flex-col items-center justify-center w-full h-screen'>
    <div className='container flex flex-col items-center w-3/5 h-4/5 gap-5  border-black'>
      <h1 className='head font-bold text-2xl text-orange-500'>Todo List</h1>

    <div className='w-auto bg-white flex justify-evenly items-center border-2 p-2'>
      <input type='text' className='input-txt w-4/5' placeholder='Add Item' value={inputData} onChange={(event)=>setinputData(event.target.value)}></input>
      <i className='fa fa-plus cursor-pointer hover:text-amber-400' onClick={additem}></i>
    </div>
    <div className='showitems flex flex-col items-center w-1/4 gap-2 '>
    {items.map((currElem, index)=>{
      return(
        <div className='eachitem  bg-orange-300 flex  flex-row items-center w-full justify-between p-2' key={currElem.id}>
    <h3>{currElem.name}</h3>
    <i className="fa fa-trash text-red-500 cursor-pointer" onClick={()=>deleteone(currElem.id)} ></i>


    </div>
      
    );})}
    

    </div>

    <div> <button className=' p-2 text-white bg-red-500' onClick={()=>setitems([])}> Clear All</button></div>
    
    </div>
    
     </div>
    </>
  );
}

export default App;
